__webpack_require__.p = "/devices-b2b/en/";